import { WIDGETS_API_VERSION } from "./constants";
export function getAuthHeaders(authToken) {
    return {
        Authorization: `Bearer ${authToken}`,
        "WorkOS-Widgets-Version": WIDGETS_API_VERSION,
    };
}
export function isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
export function isErrorLike(value) {
    return isObjectLike(value) && typeof value.message === "string";
}
export async function parseErrorResponse(response) {
    try {
        const json = await response.json();
        if (!isObjectLike(json) || typeof json.message !== "string") {
            return {
                status: response.status,
                message: response.statusText,
            };
        }
        return {
            ...json,
            status: response.status,
            message: json.message || response.statusText,
        };
    }
    catch {
        return {
            status: response.status,
            message: response.statusText,
        };
    }
}
//# sourceMappingURL=utils.js.map